import { ActionByType } from "./ProfileDocument";
import { Training } from "./Training";

export type TrainingDocument = {
    id: number;
    fileUrl: string;
    fileKey: string;
    contentType: string;
    issueDate: string;
    expirationDate: string;
    training: Training | undefined;
    lifetimeValidity: boolean;
    displayName: string;
    actionByType: ActionByType;
}

export enum TrainingDocumentOperationType {
    LOAD = "LOAD",
    UPLOAD = "UPLOAD",
    DOWNLOAD = "DOWNLOAD",
    EDIT = "EDIT",
    DELETE = "DELETE",
}

export enum TrainingDocumentStatus {
    NOT_UPLOADED = "NOT_UPLOADED",
    UPLOADED = "UPLOADED",
    EXPIRING_SOON = "EXPIRING_SOON",
    EXPIRED = "EXPIRED",
}

export const TrainingDocumentStatusLabel: {
    [key in TrainingDocumentStatus]: string;
} = {
    [TrainingDocumentStatus.NOT_UPLOADED]: "Not Uploaded",
    [TrainingDocumentStatus.UPLOADED]: "Uploaded",
    [TrainingDocumentStatus.EXPIRING_SOON]: "Expiring Soon",
    [TrainingDocumentStatus.EXPIRED]: "Expired",
};